import { ALL_TUTORIALS } from './tutorial-type';
import { ALL_WIDGETS, WidgetType } from './widget-type';
import { ALL_WIDGET_ZONE_TYPES, WidgetZoneType } from './widget-zone-type';

/** Basic targeting options. Used when comparing against targeting database. */
export interface ObjectTargeting {
  countries: string[];
  sites: string[];
}

/** Extended targeting options that also requires a user object (from graph). Cannot be used for bulk comparisons. */
export interface ObjectTargetingWithUser extends ObjectTargeting {
  isStoreCoWorker: boolean;
  isIngkaCentresCoWorker: boolean;
  isConsultant: boolean;
}

/**
 * Targeting options plus client side only properties.
 *
 * Currently, this is only used by experiments, which is client side only.
 */
export interface ObjectTargetingClientSide extends ObjectTargetingWithUser {
  isMobileDevice: boolean;
}

/**
 * Targeting preferences for widget zones.
 * Default: All widgets enabled + NOT Default
*/
export const WIDGET_ZONE_TARGETING: { [key: string]: { default?: Partial<ObjectTargetingWithUser> } } = {
  ...ALL_WIDGET_ZONE_TYPES.reduce((m, t) => {
    m[t] = {};
    return m;
  }, {}),

  // store co-workers
  [WidgetZoneType.salesandrange]: { default: { isStoreCoWorker: true } },

  // Everyone
  [WidgetZoneType.planyourday]: { default: {} },
  [WidgetZoneType.communicationandcollab]: { default: {} },

  // None store co-worker
  [WidgetZoneType.tools]: { default: { isStoreCoWorker: false } },
};

/**
 * Updated targeting preferences for widgets.
 * Default: All widgets enabled + NOT Default
*/
export const WIDGET_TARGETING_V2: { [key: string]: { enabled?: Partial<ObjectTargetingWithUser>; default?: Partial<ObjectTargetingWithUser> } } = {
  ...ALL_WIDGETS.reduce((m, t) => {
    m[t] = {};
    return m;
  }, {}),

  // store co-workers
  [WidgetType.sales]: { default: { isStoreCoWorker: true } },
  [WidgetType.livligSellThePlan]: { default: { isStoreCoWorker: true } },
  [WidgetType.livligSpotlight]: { default: { isStoreCoWorker: true } },

  // Ingka centres special rules?
  [WidgetType.visitationIndex]: {
    enabled: { isIngkaCentresCoWorker: true },
    default: { isStoreCoWorker: false },
  },

  // office
  [WidgetType.translation]: { default: { isStoreCoWorker: false } },

  // both
  [WidgetType.email]: { default: {} },
  [WidgetType.sharePointFiles]: { default: {} },
  [WidgetType.files]: { default: {} },
  [WidgetType.contacts]: { default: {} },
  [WidgetType.social]: { default: {} },
  [WidgetType.tasks]: { default: {} },
  [WidgetType.calendar]: { default: {} },

};

/**
 * Targeting preferences for tutorials. Tutorials can only be compared against targeting database (and not azure user object)
 * Default: All tutorials enabled
*/
export const TUTORIAL_TARGETING: { [key: string]: { enabled?: Partial<ObjectTargeting> } } = {
  ...ALL_TUTORIALS.reduce((m, t) => {
    m[t] = {};
    return m;
  }, {}),
};

/**
 * A/B experiments.
 * Default: All experiments off
*/
export const EXPERIMENT_TARGETING: { [key: string]: { enabled?: Partial<ObjectTargetingClientSide> } } = {};
